import React from 'react';
import clsx from 'clsx';
import { useStyles } from './styles';

import { EstimateTitleWithPopup } from '../PropertyEstimate/EstimateTitleWithPopup/EstimateTitleWithPopup';
import ContentLoader from '../../../../../../../components/loaders/ContentLoader';
import useDesktop from '../../../../../../../hooks/useDesktop';

export function EstimateCardHeader({ isLoading }) {
  const classes = useStyles();
  const isDesktop = useDesktop();

  return (
    <div
      className={clsx(
        isDesktop ? classes.cardHeader : classes.cardHeaderMobile
      )}
    >
      {isLoading ? (
        <ContentLoader display="inline-flex" height={30} width="45%" />
      ) : (
        <>
          <EstimateTitleWithPopup />
        </>
      )}
    </div>
  );
}
